import { add } from 'date-fns';

import { formatDate, SERVER_DATE_FORMAT, today } from '../../utils/dateUtils';
import { DashboardWidget } from '../DashboardWidget/DashboardWidget';

const def: DashboardWidgetDefinition = {
    id: 'upcoming_withdrawals',
    title: 'Withdrawals',
    type: 'withdrawal',
    filters: [
        {
            id: 'cashflowDate',
            value: {
                from: formatDate(today(), SERVER_DATE_FORMAT),
                to: formatDate(add(today(), { days: 30 }), SERVER_DATE_FORMAT),
            },
        },
    ],
    sort: [{ id: 'cashflowDate', desc: false }],
    columnIds: [
        'householdName',
        'portfolioName',
        'portfolioTaxType',
        'cashflowDate',
        'cashflowUnadjustedAmount',
        'withdrawalTaxRate',
        'cashflowFinalAmount',
    ],
};

export const UpcomingWithdrawals = () => <DashboardWidget widgetDefinition={def} />;
